import * as React from "react";
import {RestDataLoader} from "../../dashboard/widgets/unilever/RestDataLoader";
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;

interface AddAlarmNotePanelProps {
    alarmGuid: string;
    alarmPanel: any;
}

interface AddAlarmNotePanelState {
    alarmNote: string;
    closable: boolean;
}

function addAlarmNote(alarmGuid: string, note: string, success?: (d: any) => void) {
    RestDataLoader.postJSON(
        "alarms/" + alarmGuid + "/workOrder",
        {note},
        success,
        () => null,
    );
}

function addAlarmNoteAndCloseAlarm(alarmGuid: string, notes: string, success?: (d: any) => void): void {
    RestDataLoader.deleteJSON(
        "alarms/active/" + alarmGuid + "?notes=" + encodeURIComponent(notes),
        {},
        success,
        () => null,
    );
}

export class TerminalAddAlarmNotePanel extends React.Component<AddAlarmNotePanelProps, AddAlarmNotePanelState> {
    constructor(props: AddAlarmNotePanelProps) {
        super(props);
        this.state = {
            alarmNote: "",
            closable: false,
        };
    }

    public componentDidMount() {
        RestDataLoader.loadData(
            "alarms/" + this.props.alarmGuid,
            {},
            (alarm) => {
                if (alarm) {
                    this.setState({closable: alarm.closable});
                }
            },
            () => null,
        );
    }

    public render() {
        return (
            <div
                className="alarmPanelTerminalQuestionButtonContent"
                style={{marginTop: 0}}
            >
                <div className="alarmNote">
                    <div className="addAlarmNoteTextWrapper">
                        <div className="leftSide">
                            <h2 className="header-text">{AppTranslations.predictiveTranslation.addNoteTitle}</h2>
                            <textarea
                                className="note-textarea"
                                onChange={this.setNote}
                                value={this.state.alarmNote}
                            />
                        </div>
                        <div className="rightSide" style={{marginBottom: -20}}>
                            <div className="takeInCharge">
                                <div
                                    id="addAlarmNoteBtn"
                                    className="alarmDetailButton"
                                    style={{backgroundColor: "#a8a8a8", width: 35, height: 35}}
                                    onClick={this.addAlarmNote}
                                >
                                    <div className="onButton">
                                        <div className="icon alarmOpenWorkOrderIcon"/>
                                    </div>
                                    <div className="icon alarmOpenWorkOrderIcon"/>
                                </div>
                                <p>{AppTranslations.predictiveTranslation.manageAlarm}</p>
                            </div>
                            {this.state.closable ? <div className="closeAlarmBtn" id="addAlarmNoteBtnAndCloseWrapper">
                                <div
                                    id="addAlarmNoteBtnAndClose"
                                    className="alarmDetailButton"
                                    style={{backgroundColor: "#a8a8a8", width: 35, height: 35}}
                                    onClick={this.closeAlarm}
                                >
                                    <div className="onButton">
                                        <div className="icon closeAlarmOpenWorkOrderIcon"/>
                                    </div>
                                    <div className="icon closeAlarmOpenWorkOrderIcon"/>
                                </div>
                                <p style={{margin: 0, textAlign: "center"}}>
                                    {AppTranslations.predictiveTranslation.closeAlarm}
                                </p>
                            </div> : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private setNote = (e) => {
        this.setState({
            alarmNote: e.target.value,
        });
    }

    private addAlarmNote = () => {
        addAlarmNote(this.props.alarmGuid, this.state.alarmNote, () => {
            this.props.alarmPanel.close(() => null, true);
        });
    }

    private closeAlarm = () => {
        addAlarmNoteAndCloseAlarm(this.props.alarmGuid, this.state.alarmNote, () => {
            this.props.alarmPanel.close(() => null, true);
        });
    }
}
